// Quote author module
// Converts {{quote-author: Author Name}} to styled quote attribution
// Must be placed in the paragraph immediately after the blockquote

/**
 * @param {Element} container
 */
export function processQuoteAuthors(container) {
  const quoteAuthorRegex = /\{\{quote-author:\s*([^}]+)\}\}/;

  container.querySelectorAll('p').forEach(paragraph => {
    const text = paragraph.textContent.trim();
    const match = text.match(quoteAuthorRegex);
    if (!match) return;

    const authorName = match[1].trim();

    // Only look at the immediately preceding sibling — no broad search
    const prev = paragraph.previousElementSibling;
    const blockquote = prev?.tagName === 'BLOCKQUOTE' ? prev : null;

    if (!blockquote) {
      console.warn(`[Quote Author] Author "${authorName}" found but no blockquote immediately before it. Place {{quote-author: ...}} in the paragraph right after a blockquote.`);
    }

    // Build the author element
    const authorEl = document.createElement('div');
    authorEl.className = 'quote-author';
    const authorSpan = document.createElement('span');
    authorSpan.className = 'quote-author__text';
    authorSpan.textContent = authorName;
    authorEl.appendChild(authorSpan);

    // Remove the marker and replace/insert
    const paragraphHTML = paragraph.innerHTML || '';
    const htmlMatch = paragraphHTML.match(/\{\{quote-author:\s*[^}]+\}\}/);

    if (htmlMatch) {
      const updated = paragraphHTML.replace(htmlMatch[0], '').trim();
      if (updated) {
        paragraph.innerHTML = updated;
        paragraph.parentNode.insertBefore(authorEl, paragraph.nextSibling);
      } else {
        paragraph.replaceWith(authorEl);
      }
    } else {
      paragraph.textContent = paragraph.textContent.replace(match[0], '').trim();
      if (paragraph.textContent.trim()) {
        paragraph.parentNode.insertBefore(authorEl, paragraph.nextSibling);
      } else {
        paragraph.replaceWith(authorEl);
      }
    }

    if (blockquote) {
      blockquote.classList.add('has-author');
      authorEl.classList.add('quote-author--attached');
      if (blockquote.classList.contains('kg-blockquote-alt')) {
        authorEl.classList.add('quote-author--centered');
      }
    }
  });
}
